var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1004 17.3702V10.3353C20.1004 9.24543 19.6147 8.21325 18.7775 7.52387L14.2775 3.81841C12.9523 2.72719 11.0485 2.7272 9.72326 3.81841L5.22327 7.52387C4.38607 8.21325 3.90039 9.24543 3.90039 10.3353V17.3702C3.90039 19.3749 5.51217 21 7.50039 21H16.5004C18.4886 21 20.1004 19.3749 20.1004 17.3702Z",
    fill: "transparent",
    stroke: "#C7CBD7",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 17.4004H13.7992",
    stroke: "#C7CBD7",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9bd44ee1a9c1cfa59b9519734e2bfd2c.svg";
export { ForwardRef as ReactComponent };